<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="pt-1">
            <i :class="notifications.icon" class="mr-1"></i>
            <span>{{ notifications.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>
      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Received" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="created_at" v-model="created_at" :opens="'right'" :locale-data="{
              direction: 'ltr',
              format: 'dd/mm/yy HH:MM',
              applyLabel: 'Apply It',
              cancelLabel: '< Back',
              daysOfWeek: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat',
              ],
              monthNames: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
              ],
              firstDay: 1,
            }" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true" :timePicker="true" :timePicker24Hour="true">
                    </daterangepicker>
                    <!-- :single-date-picker="'range'" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
              created_at = {
                startDate: null,
                endDate: null,
              }
              ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="notifications.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Type" label-for="type" label-cols="12">
                  <b-input-group>
                    <treeselect instanceId="type" type="number" v-model="type" :clearable="true"
                      :options="type_options">
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="notifications.debounce"
                      placeholder="Category"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Locator" label-for="locator" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="locator" v-model="locator" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Locator" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="locator = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Archive?" label-for="archive" label-cols="12">
                      <treeselect placeholder="All" instanceId="archive" type="number" v-model="isarchive"
                        :clearable="true" :options="options_archive"></treeselect>
                    </b-form-group></b-col>
                  <b-col>
                    <b-form-group label="New?" label-for="isnew" label-cols="12">
                      <treeselect placeholder="All" instanceId="isnew" type="number" v-model="isnew" :clearable="true"
                        :options="options_isnew"></treeselect>
                    </b-form-group></b-col>
                </b-row>
              </b-col>
              <b-col v-if="user.permissions.includes('notifications.admin')" cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Agent" label-for="user" label-cols="12">
                  <treeselect placeholder="All" searchPromptText="Type at least 3 chars..." v-model="email"
                    :clearable="true" :async="true" :load-options="treeselect_loadUser" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                    @select="treeselect" :disabled="!user.permissions.includes('notifications.admin')">

                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="notifications" :icon="notifications.icon"
            :toolbarlibrary="notifications.toolbarlibrary" :tools="notifications.tools" :badges="notifications.badges"
            :fields="notifications.fields" :items="notifications.items" :busy="notifications.busy"
            :limit="notifications.limit" :page="notifications.page" :showpages="true" :selectmode="'single'"
            @load="notifications_load" @click="notifications_click" @select="notifications_select">
          </d-table>
        </div>
      </div>
      <div v-if="component">
        <component :is="component" :selection="notifications.selected" :config="cconfig"
          @discard="notifications_click('discard')" @refresh="notifications_click('go')"></component>
      </div>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import NotificationEdit from "./Components/NotificationEdit";

export default {
  name: "notifications",
  components: {
    NotificationEdit,
  },
  watch: {
    async created_at() {
      await this.notifications_load(0);
    },
    async isarchive() {
      await this.notifications_load(0);
    },
    async isnew() {
      await this.notifications_load(0);
    },
    async description() {
      await this.notifications_load(0);
    },
    async type() {
      await this.notifications_load(0);
    },
    async category() {
      await this.notifications_load(0);
    },
    async locator() {
      await this.notifications_load(0);
    },
    email: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.notifications_load(0);
      }
    },
  },
  data() {
    return {
      created_at: {
        startDate: this.$moment().subtract(1, "h").format("YYYY-MM-DDTHH:mm"),
        endDate: this.$moment().add(1, "h").format("YYYY-MM-DDTHH:mm"),
      },
      email: null,
      isarchive: false,
      isnew: true,
      options_archive: [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ],
      options_isnew: [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ],
      description: null,
      type: null,
      type_options: [
        { id: "0", label: "Alert" },
        { id: "1", label: "OK" },
        { id: "2", label: "Message" },
      ],
      category: null,
      locator: [],

      notifications: {
        title: "Notifications",
        icon: "fa fa-bell text-primary pl-2",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,clipboard,add,edit,deleteconfirm,alarmoff,email",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-bell-slash-o text-primary",
            position: "toolbar",
            action: "alarmoff",
            label: "Alarm Off",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-envelope text-warning",
            position: "toolbar",
            action: "email",
            label: "Email",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "to",
            label: "To",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            // class: "text-left"
          },
          // {
          //   key: "from",
          //   label: "From",
          //   sortable: true,
          //   sortDirection: "desc",
          //   type: "text",
          // },
          {
            key: "since",
            label: "Since",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000).utc(false)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },
          {
            key: "created_at",
            label: "Created At",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000).utc(false)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
          },
          {
            key: "type",
            label: "Status Now",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "type",
            type: "badge",
            Alert: "danger",
            OK: "success",
            Info: "info",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case 0:
                  return "Alert";
                case 1:
                  return "OK";
                case 2:
                  return "Info";
                default:
                  return value;
              }
            },
          },
          {
            key: "category",
            type: "badge",
            other: "secondary",
          },
        ],
        items: [],
        selected: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    this.email = this.user.email
  },

  methods: {
    accessdenied() {
      this.notifications.denied = [];
      if (!this.user.permissions.includes("notifications.delete")) {
        this.notifications.denied.push("deleteconfirm");
        this.notifications.denied.push("alarmoff")
      }
      if (!this.user.permissions.includes("notifications.save")) {
        this.notifications.denied.push("add");
        this.notifications.denied.push("save");
        this.notifications.denied.push("email")
      }
    },
    async notifications_load(offset, limit, page) {

      let state = this.notifications;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        isarchive: this.isarchive,
        locator: this.locator.length > 0 ? this.locator.join(",") : null,
        isnew: this.isnew,
        created_at: [
          this.created_at.startDate
            ? this.$moment(this.created_at.startDate).format("YYYY-MM-DD HH:mm")
            : null,
          this.created_at.endDate
            ? this.$moment(this.created_at.endDate).format("YYYY-MM-DD HH:mm")
            : null,
        ],
        description: this.description,
        category: this.category,
        type: this.type,
        to: this.user.permissions.includes('notifications.admin') ? this.email : this.user.email,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query notifications(
              $limit: Int
              $offset: Int
              $id: String
              $isarchive: Boolean
              $isnew: Boolean
              $date: [String]
              $description: String
              $type: String
              $to: String
              $category: String
              $locator: String
            ) {
              notifications(
                limit: $limit
                offset: $offset
                id: $id
                isarchive: $isarchive
                isnew: $isnew
                date: $date
                description: $description
                type: $type
                to: $to
                category: $category
                locator: $locator
              ) {
                id
                archive
                new
                locator
                description
                type
                due
                category
                data
                link
                from
                to
                watch
                since
                updated_at
                created_at
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.notifications
        } else {
          state.items = []
          state.items = response.data.notifications;
        }

      } catch (error) {
        console.log(error);
      }
      this.$store.dispatch("notifications");
      state.busy = false;

    },
    async notifications_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.notifications_load();
          break;
        case "add":
        case "edit":
          this.component = "NotificationEdit";
          break;
        case "delete":
          await this.notifications_delete(ss);
          break;
        case "alarmoff":
          await this.notifications_clear(ss)
          break;
        case "email":
          await this.notifications_email(ss)
          break;
      }
    },

    async notifications_select(ss, tools) {

      let state = this.notifications;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "clipboard", "alarmoff", "email"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "view"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async notifications_delete(ss) {
      console.log("notifications_delete", ss);

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
           mutation notifications_delete($rows: [Notification_input]) {
            notifications_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.notifications_load(0);
    },

    async notifications_clear(ss) {
      console.log("notifications_clear", ss);

      let state = this.notifications;

      state.busy = true

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
           mutation notifications_clear {
            notifications_clear
            }
          `,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.notifications_load(0);
    },

    async notifications_email(ss) {
      console.log("notifications_email", ss);

      let state = this.notifications;

      state.busy = true

      try {
        const response = await this.$apollo.mutate({
          query: gql`
           query notifications_email {
            notifications_email
            }
          `,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.notifications_load(0);
    },
  },
};
</script>

<style></style>